import React from 'react';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <div className="contents">
      <div className="contents-wrapper">
        <div className="section-gap">
          <h1>Privacy Policy</h1>

          <h3>• Information We Collect</h3>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              Personal Information: We collect personal details such as your name, email address, shipping address,
              phone number, and payment information when you make a purchase, create an account, or contact us.
            </li>
            <li>
              Non-Personal Information: We may collect non-personal data such as browser type, operating system, and
              browsing behavior to improve our website and services.
            </li>
          </ul>

          <h3>• How We Use Your Information</h3>
          <ul style={{ marginLeft: '20px' }}>
            <li>To Process Orders: We use your personal information to process and fulfill your orders.</li>
            <li>
              To Communicate: We use your contact information to send you updates about your order, respond to
              inquiries, and send promotional materials if you have opted in.
            </li>
            <li>
              To Improve Our Services: We analyze non-personal information to understand user behavior and enhance our
              website’s performance.
            </li>
          </ul>
          <h3>• Data Security</h3>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              We implement appropriate security measures to protect your personal information from unauthorized access,
              alteration, disclosure, or destruction.
            </li>
          </ul>
          <h3>• Your Rights</h3>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              Access and Correction: You have the right to access and correct your personal information. You can update
              your account details through our website.
            </li>
            <li>
              Opt-Out: You can opt-out of receiving promotional emails by following the unsubscribe instructions in the
              emails.
            </li>
          </ul>
          <h3>• Changes to This Policy</h3>
          <ul style={{ marginLeft: '20px' }}>
            <li>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page, and the
              revised date will be indicated at the top of the policy.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
